@if(supplyDrop().status === 'running') {
<div class="join">
  <svg-icon
    class="drop-background"
    src="assets/images/ui-effects/background-vector-left.svg"
  ></svg-icon>
    <img class="drop-icon open-link" src="assets/images/cases/3_bronze/bronze_5.png" alt="Supply Drop"
         (click)="openCaseSkinsModal()"
    />
    <div class="name-wrapper">
        <div class="drop-name">Supply Drop</div>
        <div class="drop-name drop-name--highlight open-link" (click)="openCaseSkinsModal()">Bronze V Case</div>
    </div>

    <div class="drop-info flex items-center">
    <countdown
      #cd
      class="countdown"
      [config]="{
        stopTime: (supplyDrop().supplyDropInformation?.end_time ?? 0) * 1000,
        format: 'mm:ss'
      }"
    />
        <span class="separator"></span>
        <div class="drop-players flex items-center">
            {{ supplyDrop().players }}
        </div>
  </div>
  <button
    type="button"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="openOverlay()"
    class="drop-join button button--style-yellow h-32 rounded-4 padding-x-12"
  >
    Join
  </button>
  @if (supplyDrop().captcha) {
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isCaptchaOverlay"
    (detach)="isCaptchaOverlay = false"
    cdkConnectedOverlayPanelClass="context-menu-panel"
  >
    <app-captcha-overlay
      [captcha]="supplyDrop().captcha!"
      (closeCaptchaOverlay)="isCaptchaOverlay = false"
      (verifyCaptcha)="handleVerifyCaptcha($event)"
    ></app-captcha-overlay>
  </ng-template>
  }
</div>
} @else { @if (rollStatus() === 'avatars') {
<div class="roll-container" #rollContainerAvatars>
  @if (isRolling()) {
  <svg-icon
    class="flex items-center justify-center roll-indicator top"
    src="assets/icons/cases/roll-indicator.svg"
    style="--indicator-color: var(--yellow)"
    animate.enter="animate-fade-in" animate.leave="animate-fade-out"
  />
  <svg-icon
    class="flex items-center justify-center roll-indicator bottom"
    src="assets/icons/cases/roll-indicator.svg"
    style="--indicator-color: var(--yellow)"
    animate.enter="animate-fade-in" animate.leave="animate-fade-out"
  />
  }
  <div class="roll-wrapper flex items-center" #rollWrapperAvatars>
    @for (avatar of avatars(); track $index) {
    <div
      class="item avatar flex items-center justify-center"
      [attr.data-name]="supplyDrop().supplyDrop?.winner?.name"
    >
      <img
        [src]="avatar"
        loading="lazy"
        width="28"
        height="28"
        alt="supply drop participant avatar"
      />
      @if (showAvatarsRollResults() && wonIndex() === $index) {
      <div class="item-extra" animate.enter="animate-fade-in" animate.leave="animate-fade-out">
        <div class="item-name">
          {{ supplyDrop().supplyDrop?.winner?.name }}
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>
}
<!--  -->
@if (rollStatus() === 'skins') {
<div class="roll-container" #rollContainerSkins>
  @if (isRolling()) {
  <svg-icon
    class="flex items-center justify-center roll-indicator top"
    src="assets/icons/cases/roll-indicator.svg"
    style="--indicator-color: var(--yellow)"
    animate.enter="animate-fade-in" animate.leave="animate-fade-out"
  />
  <svg-icon
    class="flex items-center justify-center roll-indicator bottom"
    src="assets/icons/cases/roll-indicator.svg"
    style="--indicator-color: var(--yellow)"
    animate.enter="animate-fade-in" animate.leave="animate-fade-out"
  />
  }
  <div class="roll-wrapper flex items-center" #rollWrapperSkins>
    @for (skin of skins(); track $index) {
    <div
      class="item skin flex items-center justify-center"
      [class.results]="showSkinsRollResults() && wonIndex() !== $index"
      [attr.data-name]="skin.name"
      [style.--skin-color]="skin.color"
    >
      <img
        [src]="skin.image"
        loading="lazy"
        width="28"
        height="28"
        [alt]="skin.name"
      />
      @if (showSkinsRollResults() && wonIndex() === $index) {
      <div class="item-extra bg" animate.enter="animate-fade-in" animate.leave="animate-fade-out">
        <div class="item-name">
          {{ skin.name }}
        </div>
        <app-cost
          [gap]="0"
          class="item-cost"
          [cost]="skin.price"
          [balanceType]="'skins'"
        ></app-cost>
      </div>
      }
    </div>
    }
  </div>
</div>
} }
